import React, { useEffect, useMemo } from "react";

import { LiveWidgetStore } from "@state/stores/live-widgets";

import { LiveWidgetStoreContext } from ".";

export function LiveWidgetProvider(props: {
	children: JSX.Element | JSX.Element[];
	/** If true it will disable  */
	shouldSuspendWidgets: boolean;
}) {
	const store = useMemo(() => new LiveWidgetStore(), []);

	useEffect(() => {
		store.onInitialize();
		return () => store.onDispose();
	}, []);

	useEffect(() => {
		store.setWidgetSuspend(props.shouldSuspendWidgets);
	}, [props.shouldSuspendWidgets]);

	return (
		<LiveWidgetStoreContext.Provider value={store}>
			{props.children}
		</LiveWidgetStoreContext.Provider>
	);
}
